import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import ApiService from '../../../services/ApiService'
import { confirmationAlert, showAlert } from '../../../utility/SweetAlert'

const InteractorFundBillUpdate = () => {
  const { t } = useTranslation()
  const fundBillUpdate = useCallback(
    (payload, loading, invoice_code, confirmationType = {}) => {
      const refundMessage = `${
        payload.status === 'REFUND_PROCESS'
          ? t('message.confirm_reject_withdraw')
          : t('message.confirm_approve_withdraw')
      } ${invoice_code}`
      confirmationAlert({
        message: confirmationType?.message ?? refundMessage,
        icon: 'question',
      }).then(result => {
        if (result === true) {
          ApiService.jsonRequest('/fund-bill/update', payload, response => {
            loading(false)
            if (response.status_code === 200) {
              showAlert({
                icon: 'success',
                message: t('message.successfully_updated'),
                timer: 1500,
                reload: true,
              })
            } else {
              showAlert({
                icon: 'error',
                message: t(`response_message.${response.messages}`),
                timer: 1500,
              })
            }
          })
        } else {
          loading(false)
        }
      })
    },
    [t],
  )
  return { fundBillUpdate }
}

export default InteractorFundBillUpdate
